export default __webpack_public_path__ + "media/ITSM.93c91dc0a0d30622eda61ead802d180b.svg";